import {
	AMENDCONTRACT_ERROR,
	GET_AMENDCONTRACTTEAM,
	GET_AMENDCONTRACTTEAMEXPORT,
	GET_AMENDCONTRACTDETAILS,
	GET_AMENDCONTRACT_DETAILS_EXPORT,
	GET_AMENDMENTREASON,
	SAVE_AMENDCONTRACT,
	DELETE_AMENDCONTRACT,
	AMENDCONTRACT_ADD_UPDATE,
	AMENDCONTRACT_CLEAR_ALL_UPDATES,
	AMENDCONTRACT_CLEAR
} from '../Enums/AmendContract.Enums';

const initState = {
	amendContractTeam: [],
	total: 0,
	apiCallCompleted: false,
	amendContractTeamExport: [],
	amendContractDetails: [],
	amendContractDetailsExport: [],
	amendmentReason: [],
	updated: false,
	saveResponse: false,
	deleteResponse: false,
	errors: [],
	message: ''
};

const amendContractReducer = (state = initState, action) => {
	let updatedState = {};
	const { type, payload } = action;

	switch (type) {
		case GET_AMENDCONTRACTTEAM:
			updatedState = {
				...state,
				amendContractTeam: payload.data,
				total: payload.total,
				errors: payload.errors,
				apiCallCompleted: true,
				message: ''
			};
			break;
		case GET_AMENDCONTRACTTEAMEXPORT:
			updatedState = {
				...state,
				amendContractTeamExport: payload.data,
				errors: payload.errors
			};
			break;
		case GET_AMENDCONTRACTDETAILS:
			updatedState = {
				...state,
				amendContractDetails: payload.data,
				errors: payload.errors,
				apiCallCompleted: true,
				message: ''
			};
			break;
		case GET_AMENDCONTRACT_DETAILS_EXPORT:
			updatedState = {
				...state,
				amendContractDetailsExport: payload.data,
				errors: payload.errors
			};
			break;
		case GET_AMENDMENTREASON:
			updatedState = {
				...state,
				amendmentReason: payload.data,
				errors: payload.errors
			};
			break;
		case SAVE_AMENDCONTRACT:
			updatedState = {
				...state,
				saveResponse: payload.data,
				errors: payload.errors,
				updated: false
			};
			break;
		case DELETE_AMENDCONTRACT:
			updatedState = {
				...state,
				deleteResponse: payload.data,
				errors: payload.errors,
				updated: false
			};
			break;
		case AMENDCONTRACT_ADD_UPDATE:
			updatedState = {
				...state,
				updated: payload.update,
				errors: payload.errors
			};
			break;
		case AMENDCONTRACT_CLEAR_ALL_UPDATES:
			updatedState = {
				...state,
				amendContractTeam: [],
				total: 0,
				apiCallCompleted: false,
				amendContractTeamExport: [],
				amendContractDetails: [],
				amendContractDetailsExport: [],
				updated: false,
				saveResponse: false,
				deleteResponse: false,
				errors: [],
				message: ''
			};
			break;
		case AMENDCONTRACT_CLEAR:
			updatedState = {
				...state,
				errors: [],
				message: ''
			};
			break;
		case AMENDCONTRACT_ERROR:
			updatedState = {
				...state,
				errors: payload.errors,
				apiCallCompleted: true,
				updated: false
			};
			break;
		default:
			return state;
	}

	return updatedState;
};

export default amendContractReducer;
